import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/Top5MistakesRectifiersHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-6.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .t5m { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .t5m-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .t5m-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .t5m-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .t5m-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .t5m-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .t5m-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .t5m-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .t5m-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .t5m-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .t5m-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .t5m-bc-item:hover { color: #EB2019; }
  .t5m-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .t5m-bc-sep img { width: 24px; height: 24px; display: block; }
  .t5m-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .t5m-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .t5m-main-section { padding: 80px 0 120px 0; }
  .t5m-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .t5m-article { flex: 1; min-width: 0; }

  .t5m-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .t5m-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .t5m-meta-item:last-child { border-right: none; padding-right: 0; }
  .t5m-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .t5m-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .t5m-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .t5m-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .t5m-article-body p { margin-bottom: 15px; }
  .t5m-article-body p:last-child { margin-bottom: 0; }

  .t5m-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  .t5m-article-body strong { font-weight: 600; color: #202020; }

  .t5m-red-link { color: #EB2019; text-decoration: underline; }
  .t5m-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .t5m-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .t5m-bottom-nav { display: flex; align-items: center; gap: 30px; }
  .t5m-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .t5m-nav-btn:hover { color: #EB2019; }
  .t5m-nav-btn img { width: 40px; height: 40px; display: block; }

  .t5m-share-icons { display: flex; align-items: center; gap: 20px; }
  .t5m-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .t5m-share-icon:hover { opacity: 0.85; }
  .t5m-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .t5m-sidebar { flex: 0 0 475px; }
  .t5m-sidebar-block { margin-bottom: 60px; }
  .t5m-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .t5m-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .t5m-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .t5m-recent-item:hover .t5m-recent-title { color: #EB2019; }
  .t5m-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .t5m-recent-body { flex: 1; min-width: 0; }
  .t5m-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .t5m-social-icons { display: flex; align-items: center; gap: 30px; }
  .t5m-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .t5m-social-icon:hover { opacity: 0.8; }
  .t5m-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .t5m-hero             { height: 350px; }
    .t5m-hero-content     { padding: 0 32px; }
    .t5m-hero-title       { font-size: 30px; }
    .t5m-hero-divider     { width: 100%; max-width: 479px; }
    .t5m-breadcrumb       { padding: 24px 0 0 0; }
    .t5m-breadcrumb-inner { padding: 0 32px; }
    .t5m-inner            { padding: 0 32px; }
    .t5m-main-section     { padding: 48px 0 60px 0; }
    .t5m-main-row         { flex-direction: column; gap: 48px; }
    .t5m-sidebar          { flex: none; width: 100%; }
    .t5m-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .t5m-hero             { height: 360px; }
    .t5m-hero-content     { padding: 0 16px; }
    .t5m-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .t5m-hero-divider     { width: 100%; }
    .t5m-hero-subtitle    { font-size: 14px; }
    .t5m-breadcrumb       { padding: 30px 0 0 0; }
    .t5m-breadcrumb-inner { padding: 0 16px; }
    .t5m-bc-item          { font-size: 14px; gap: 14px; }
    .t5m-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .t5m-bc-sep img       { width: 22px; height: 22px; }
    .t5m-inner            { padding: 0 16px; }
    .t5m-main-section     { padding: 30px 0 60px 0; }
    .t5m-main-row         { flex-direction: column; gap: 60px; }
    .t5m-sidebar          { flex: none; width: 100%; }
    .t5m-sidebar-title { font-size: 20px;}
    .t5m-article-title    { font-size: 20px; margin-bottom: 15px; }
    .t5m-article-body     { font-size: 14px; }
    .t5m-meta-item        { font-size: 14px; }
    .t5m-article-img      { margin: 30px 0 30px 0; height: 250px; }
    .t5m-h2               { font-size: 16px; margin: 20px 0 15px 0; }
    .t5m-nav-btn img      { width: 24px; height: 24px; }
    .t5m-nav-btn          { font-size: 14px; }
    .t5m-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function Top5MistakesBuyingRectifiers() {
  return (
    <div className="t5m">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="t5m-hero">
        <img className="t5m-hero-bg" src={HeroBgImg} alt="Top 5 Mistakes Rectifiers Hero" />
        <div className="t5m-hero-overlay" />
        <div className="t5m-hero-content">
          <h1 className="t5m-hero-title">
            Top 5 Mistakes Industries Make When Buying Rectifiers — &amp; How to Avoid Them
          </h1>
          <hr className="t5m-hero-divider" />
          <p className="t5m-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="t5m-breadcrumb" aria-label="Breadcrumb">
        <div className="t5m-breadcrumb-inner">
          <a href="/" className="t5m-bc-item">Home</a>
          <span className="t5m-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="t5m-bc-item">News &amp; Updates</a>
          <span className="t5m-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="t5m-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="t5m-main-section">
        <div className="t5m-inner">
          <div className="t5m-main-row">

            {/* ── ARTICLE ── */}
            <article className="t5m-article">

              {/* Meta bar */}
              <div className="t5m-meta-bar">
                <span className="t5m-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="t5m-meta-item"><img src={CalendarIcon} alt="date" /> June 17, 2025</span>
                <span className="t5m-meta-item"><img src={ClockIconImg} alt="time" /> 11:34 am</span>
                <span className="t5m-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="t5m-article-title">
                Top 5 Mistakes Industries Make When Buying Rectifiers — and How to Avoid Them
              </h1>

              {/* Body */}
              <div className="t5m-article-body">

                <p>The <strong>rectifier</strong> is a crucial component in pollution control and high-voltage systems, such as electrostatic precipitators. Still, many industries make common mistakes in choosing the right rectifier.</p>

                <p>f you are planning to invest in a new rectifier, this blog is your guide to getting it right. Let's discuss the top 5 mistakes industries make and how to avoid them.</p>

                {/* Article image */}
                <img className="t5m-article-img" src={ArticleImg} alt="Industrial Rectifier" />

                <span className="t5m-h2">Don't Let the Price Tag Cost You More</span>

                <p>We understand that saving money is essential for your business. But do you know that choosing the cheapest <strong>rectifier</strong> can cost you far more? More affordable models often mean lower reliability, higher maintenance costs, and traditional technology that struggles to keep pace with today's system demands.</p>

                <span className="t5m-h2">Compatibility with the system</span>

                <p>Ensure the rectifier matches the voltage, current capacity, and control features of your system to achieve optimal performance. The <strong>Rectifiers</strong> must align with your application, whether it's for ESPs, plating, or industrial furnaces.</p>

                <span className="t5m-h2">Plan Long-term Setup</span>

                <p>Along with current requirements, it also focuses on future capacity. Choose a rectifier that is tech-driven, like some systems today, which allows for software updates or plug-in expansions. Choose wisely and be prepared to adapt to evolving compliance standards.</p>

                <span className="t5m-h2">Absence of Smart Controls Reduces Operational Precision</span>

                <p>If you're still using a traditional rectifier, you're missing out. New rectifiers come with innovative features such as digital controls, AI-based spark management (for ESPs), and real-time performance monitoring. Seek smarter rectifiers to minimize downtime and maximize performance.</p>

                <span className="t5m-h2">Ignoring After-Sales Support</span>

                <p>Partner with a strong after-sales support brand that backs you up when things go wrong—local service teams, spare parts availability, and regular health checks.</p>

                <span className="t5m-h2">Final Thoughts</span>

                <p><strong>Still seeking a reliable rectifier solution that's smart, scalable, and long-lasting?</strong></p>

                <p><strong>Ador Powertron</strong> is trusted by many for high-performance rectifier systems for industrial applications—Ador engineer technology to deliver reliable and energy-efficient power.<br />
                Talk to our experts and avoid common mistakes. Upgrade your power game with a rectifier that's made for performance.</p>

                <p>Explore smart rectifier solutions at <strong>Ador Powertron.</strong> <a href="/contact" className="t5m-red-link">Contact us now!</a></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="t5m-bottom-row">
                <div className="t5m-bottom-nav">
                  <a href="/news/electrostatic-precipitator-market-outlook-2025-2035-trends-forecasts" className="t5m-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="t5m-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="t5m-share-icons">
                  <a href="#" className="t5m-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="t5m-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="t5m-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="t5m-sidebar">

              {/* Recent Posts */}
              <div className="t5m-sidebar-block">
                <p className="t5m-sidebar-title">Recent Posts</p>
                <div className="t5m-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="t5m-recent-item">
                      <img src={post.img} alt={post.title} className="t5m-recent-img" />
                      <div className="t5m-recent-body">
                        <span className="t5m-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="t5m-sidebar-block">
                <p className="t5m-sidebar-title">Social Media</p>
                <div className="t5m-social-icons">
                  <a href="#" className="t5m-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="t5m-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}